import { apiClient } from "../../../api";
import { Role } from "../../../types";
import {
  CreateRolePayload,
  RoleResponse,
  RolesListResponse,
  UpdateRolePayload,
  UserRolesResponse,
} from "../types";

// All role/assignment calls go through the gestor-backend proxy, which forwards to the
// private auth API.
const BASE = "/gestorUserManagement";

export const getRoles = async (ops: string): Promise<Role[]> => {
  const response = await apiClient.get<RolesListResponse>(
    `${BASE}/roles?ops=${encodeURIComponent(ops)}`
  );
  return response.data.roles ?? [];
};

// Roles across several ops (a user can belong to more than one).
export const getRolesForOps = async (opsList: string[]): Promise<Role[]> => {
  const results = await Promise.all(opsList.map((ops) => getRoles(ops)));
  return results.flat();
};

export const createRole = async (payload: CreateRolePayload): Promise<Role> => {
  const response = await apiClient.post<RoleResponse>(`${BASE}/roles`, payload);
  return response.data.role;
};

export const updateRole = async (
  id: string,
  payload: UpdateRolePayload
): Promise<Role> => {
  const response = await apiClient.patch<RoleResponse>(
    `${BASE}/roles/${id}`,
    payload
  );
  return response.data.role;
};

export const deleteRole = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/roles/${id}`);
};

export const getUserRoles = async (userId: string): Promise<string[]> => {
  const response = await apiClient.get<UserRolesResponse>(
    `${BASE}/users/${userId}/roles`
  );
  return response.data.roleIds ?? [];
};

export const setUserRoles = async (
  userId: string,
  roleIds: string[]
): Promise<void> => {
  await apiClient.put(`${BASE}/users/${userId}/roles`, { roleIds });
};
